import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from './../../Contextapi/ContextApi';
import oneworldlogo from './../../Images/oneworldlogo.jpeg';
import { baseUrl } from './../../Apiurls/Apiurls';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; 

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); 
  const [loginStatus, setLoginStatus] = useState('');
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${baseUrl}/api/login`, { email, password });

      if (res.data.message === 'Login successful') {
        login(res.data.id, res.data.name, res.data.email,res.data.role,res.data.mobile);

       // alert('Login successful');
        setEmail('');
        setPassword('');
        navigate('/view');
      } else {
        setLoginStatus(res.data.message);
      }
    } catch (err) {
      console.error(err);
      setLoginStatus('Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center mt-5">
      <div className="border p-4 rounded shadow-sm" style={{ width: '350px' }}>
        <div className="text-center mb-3">
          <img
            src={oneworldlogo}
            alt="One World Logo"
            style={{ width: '80%', borderRadius: '10px' }}
          />
        </div>
        <h4 className="text-center mb-4">Applicants Tracker</h4>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* 👁️ Password input with toggle icon */}
          <div className="mb-3 position-relative">
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#6c757d',
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="text-center mt-4">
            <button type="submit" className="btn btn-primary w-100">
              Login
            </button>
          </div>
        </form>

        {loginStatus && (
          <div className="mt-3 alert alert-danger text-center">{loginStatus}</div>
        )}
      </div>
    </div>
  );
}

export default Login;
